module.exports = __webpack_public_path__ + "img/right-arrow.48d9fcad.svg";